import React, { useState } from "react";
import Cart from "./Cart";
import { Link } from "react-router-dom";

export default function ProductView(props) {
  console.log(props);

  const product = props.location.values;

  const [cart, setCart] = useState([]);

  const cartTo = (product) => {
    setCart([...cart, product]);
  };

  const cartItems = cart.map((product) => (
    <div key={product.id}>{`${product.name},${product.price}`}</div>
  ));

  return (
    <div className="product-view">
      {product === undefined ? (
        <h2 className="text-center">
          Error Fetch Data ! Please GoBack and Try Again
        </h2>
      ) : (
        <div className="container">
          <div key={product?.id} className="row">
            <div className="col-md-6 as text-center">
              <img className="img-fluid" src={product?.image} alt="" />
            </div>
            <div className="col-md-6">
              <h2 className="product-name">{product?.name}</h2>
              {product.rating ? (
                <h6 className="product-rating">{product?.rating}</h6>
              ) : (
                ""
              )}

              <h6 className="product-selling-price">
                ₹{product?.price}
                <span className="product-original-price">
                  ₹{product?.originalprice}
                </span>
              </h6>
              <div className="row">
                <div className="col-2">
                  {product.memory ? (
                    <h6 className="product-memory">{product.memory}</h6>
                  ) : (
                    ""
                  )}
                </div>
                <div className="col">
                  {product.ram ? (
                    <h6 className="product-ram">{product.ram}</h6>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <div className="row">
                <div className="col-2">
                  {product.display ? (
                    <h6 className="product-display">{product.display}</h6>
                  ) : (
                    ""
                  )}
                </div>
                <div className="col">
                  {product.os ? (
                    <h6 className="product-os">{product.os}</h6>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              {product.weight ? (
                <h6 className="product-weight"> {product?.weight}</h6>
              ) : (
                ""
              )}
              <h6 className="available-offers">Available Offers</h6>
              <h6 className="product-offers">{product?.availableoffer}</h6>
              <h6 className="available-offers">Product Description</h6>
              <h6 className="product-description">{product?.description}</h6>
              <div className="mt-4">
                {}
                <Link
                  to={{
                    pathname: "/BuyNow",
                    value: {
                      id: product.id,
                      name: product?.name,
                      image: product.image,
                      price: product.price,
                      originalprice: product.originalprice,
                    },
                  }}
                  className="product-buy btn"
                >
                  Buy Now
                </Link>
                <button
                  className="product-add btn"
                  type="submit"
                  onClick={() => cartTo(product)}
                >
                  Add to cart
                </button>
                <div>{cartItems}</div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
